module.exports = __webpack_public_path__ + "static/media/stone.e55b843f.png";